import { ChakraImage as Image } from "@airhelp/react-ui-components";
import type { BlogFeaturedImageProps } from "./BlogFeaturedImage.d";

const BlogFeaturedImage = ({ src, alt }: BlogFeaturedImageProps) => {
  if (!src) return null;
  return <Image width="100%" objectFit="cover" height="360px" borderRadius="xl" mb="10" src={src} alt={alt} />;
};

export default BlogFeaturedImage;
